import { useNavigate } from 'react-router-dom';
import { Button, SxProps, Theme, Typography } from '@mui/material';
import { baseColors } from 'utils/constants';
import { SmartphoneWifiIcon } from 'components';

type Props = {
  id?: string;
  sx?: SxProps<Theme> | undefined;
  children?: React.ReactNode;
  onClick?: () => void;
};

const SmartphoneButton = (props: Props) => {
  const { sx } = props;
  const navigate = useNavigate();
  const handleClick = (): void => {
    navigate('/rental/ec');
  };

  return (
    <Button
      sx={{
        width: '200px',
        height: '50px',
        mx: 'auto',
        my: 0,
        p: 1,
        textAlign: 'center',
        bgcolor: baseColors.orange,
        borderRadius: '6px',
        boxShadow: 2,
        ...sx
      }}
      onClick={handleClick}
    >
      <Typography
        variant="subtitle1"
        sx={{
          display: 'flex',
          color: baseColors.white
        }}
      >
        <SmartphoneWifiIcon style={{ width: 18, marginTop: -3, marginRight: 6 }} />
        レンタルはこちら
      </Typography>
    </Button>
  );
};

export default SmartphoneButton;
